export const configSurfaceAnalysisDhGrandMaster = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_WNI_GrandMaster/index.json",
    "retain": true,
    "cache": false,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "GeoTiff",
    "name": "WX_WNI_GrandMaster",
    "url": "%wrap_url%/WX_WNI_GrandMaster/%element%/000/%basetime%/%validtime%.tiff",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "Width": 360,
      "Height": 181,
      "LatBase": 90.0,
      "LonBase": 0.0,
      "LatInterval": 1.0,
      "LonInterval": 1.0,
      "MinValue": -100,
      "MaxValue": 100000000
    }
  }
};

export const configSurfaceAnalysisUpConversionController = {
  "Controller": {
    "Name": "UpConversionFilter",
    "peak_filtering": true,
    "MaxScale": 4
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configSurfaceAnalysisDhGrandMaster,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "name": "GFS_UpConversion",
      "reference": configSurfaceAnalysisDhGrandMaster
    }
  }
};

export const configSurfaceAnalysisDhFront = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_WNI_Front/index.json",
    "retain": true,
    "cache": false,
    "cache_busting": true,
    "update_interval": 60
  },
  "data" : {
    "Type": "GeoJSON",
    "name": "WX_WNI_Front",
    "url": "%wrap_url%/WX_WNI_Front/%basetime%/%validtime%.json",
    "cache": true
  }
};

export const configSurfaceAnalysisLayerContour = {
  "Name" : "GPVPressuremslContour",
  "Renderer" : "Contour",
  "Attributes" : {
    "data_offset" : 0,
    "data_scale" : 0.01,
    "style" : {
      "default" : {
        "contour_label_priority": "ascend",
        "contour": [
          {
            "base":880,
            "interval":4,
            "num": 250,
            "unit_label": "",
            "label_interval" : 30,
            "max_label_num" : 3,
            "strokeStyle": "rgba(50,50,100,0.6)",
            "textColor": "rgba(20,20,80,0.6)"
          }
        ]
      },
      "dark" : {
        "contour_label_priority": "ascend",
        "contour": [
          {
            "base":880,
            "interval":4,
            "num": 250,
            "unit_label": "",
            "label_interval" : 30,
            "max_label_num" : 3,
            "strokeStyle": "rgba(170,170,255,0.6)",
            "textColor": "rgba(150,150,255,0.6)"
          }
        ]
      }
    }
  }
};

export const configSurfaceAnalysisLayerHiLo = {
  "Name" : "HiLo",
  "Renderer" : "HiLo",
  "Attributes" : {
    "data_offset" : 0,
    "data_scale" : 0.01,
    "style" : {
      "default" : {
        "fractional_digits" : 0,
        "unit_label": "",
        "point_size": 8,
        "mark_font_size": 14,
        "text_font_size": 13,
        "hi_mark":"H",
        "lo_mark":"L",
        "hi_point_color": "rgba(0, 0, 0, 0)",
        "hi_point_edge_color": "rgba(0, 0, 0, 0)",
        "lo_point_color": "rgba(0, 0, 0, 0)",
        "lo_point_edge_color": "rgba(0, 0, 0, 0)",
        "hi_text_color": "rgba(0, 0, 250, 0.8)",
        "hi_text_edge_color": "rgba(0, 0, 125, 0.8)",
        "lo_text_color": "rgba(250, 0, 0, 0.8)",
        "lo_text_edge_color": "rgba(125, 0, 0, 0.8)",
        "text_offset_x": 0,
        "text_offset_y": 22,
        "hi_mark_color": "rgba(0, 0, 250, 0.8)",
        "hi_mark_edge_color": "rgba(0, 0, 250, 0.8)",
        "lo_mark_color": "rgba(250, 0, 0, 0.8)",
        "lo_mark_edge_color": "rgba(250, 0, 0, 0.8)",
        "mark_offset_x": 0,
        "mark_offset_y": 5
      },
      "dark" : {
        "fractional_digits" : 0,
        "unit_label": "",
        "point_size": 8,
        "mark_font_size": 14,
        "text_font_size": 13,
        "hi_mark":"H",
        "lo_mark":"L",
        "hi_point_color": "rgba(0, 0, 0, 0)",
        "hi_point_edge_color": "rgba(0, 0, 0, 0)",
        "lo_point_color": "rgba(0, 0, 0, 0)",
        "lo_point_edge_color": "rgba(0, 0, 0, 0)",
        "hi_text_color": "rgba(0, 250, 250, 0.8)",
        "hi_text_edge_color": "rgba(0, 0, 125, 0.8)",
        "lo_text_color": "rgba(250, 0, 0, 0.8)",
        "lo_text_edge_color": "rgba(125, 0, 0, 0.8)",
        "text_offset_x": 0,
        "text_offset_y": 22,
        "hi_mark_color": "rgba(0, 250, 250, 0.8)",
        "hi_mark_edge_color": "rgba(0, 0, 250, 0.8)",
        "lo_mark_color": "rgba(250, 0, 0, 0.8)",
        "lo_mark_edge_color": "rgba(250, 0, 0, 0.8)",
        "mark_offset_x": 0,
        "mark_offset_y": 5
      }
    }
  }
};

export const configSurfaceAnalysisLayerFront = {
  "Name" : "Front",
  "Renderer" : "Front",
  "Attributes" : {
    "_min_zoom" : 1,
    "size_factor":1.7,
    "interval_factor":80.0,
    "line_width":1,
    "line_color":"#222222",
    "warm_color":"#FF3333",
    "cold_color":"#3333FF",
    "occluded_color":"#81298B"
  }
};
